'use strict';

require('./cn-round-form.scss');

module.exports = {
  template: require('./cn-round-form.html'),
  controller: require('./cn-round-form.controller'),
  controllerAs: 'vm',

  bindings: {
    questionnaires: '<',
    modal: '<',
    titleText: '@',
    buttonText: '@',
    onSubmit: '&',
    onChange: '&',
    onReset: '&',
    data: '<',
    isPerformanceReview: '<',
    performanceReviewRounds: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-round-form/index.js
 ** module id = 83
 ** module chunks = 0
 **/